import Vue from 'vue';
import Search from './components/search/search.vue';
import Notifications from './components/notifications/notifications.vue';
import Login from './views/login/login.vue';
import Sidebar from './components/sidebar/sidebar.vue';
import Shop from './components/shop/shop.vue';
import Inform from './components/inform/inform.vue';

Vue.component('search_component', Search);
Vue.component('notifications', Notifications);
Vue.component('login', Login);
Vue.component('sidebar', Sidebar);
Vue.component('shop', Shop);
Vue.component('inform', Inform);
